<template>
<!-- 商品管理 -->
    <div class="el-card pd20">
        <div class="main">
            <div class="box">
                <!--  --> 
                <div class="search">
                    <div class="search-gropu">
                        测评
                        <el-select class="search-child"  v-model="cid" placeholder="请选择测评" clearable>
                            <el-option v-for="(item,index) in courseArr" :key="index"  :label="item.title" :value="item.cid"></el-option>
                        </el-select>
                    </div>
                    <div class="search-gropu">
                        <label >用户昵称：</label>
                        <el-input class="input" v-model="nickname" placeholder="请输入用户昵称"></el-input>
                    </div>
                    <el-button type="primary" @click="pullData" size="medium">搜索</el-button>
                </div>
            
            </div>
            <!-- list-->
            <div class="el-card pd20">
                <el-table :data="list" show-overflow-tooltip border style="width: 100%">
                    <el-table-column type="index" width="50" label="序号"></el-table-column>
                    <el-table-column prop="id" label="测评结果ID" > </el-table-column>
                    <el-table-column prop="nickname" label="昵称"></el-table-column>
                    <el-table-column  label="头像" >
                        <template  slot-scope="scope">
                            <div class="userinfo">
                                <img :src="scope.row.headimgurl" alt="">
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="uid" label="用户ID"></el-table-column>
                    <el-table-column prop="cid" label="测评ID" > </el-table-column>
                    <el-table-column prop="ctime" label="测评时间"></el-table-column>
                    <el-table-column prop="title" label="测评名称" > </el-table-column>
                    
                    <el-table-column label="操作" width="250">
                        <template slot-scope="scope">
                            <el-button type="primary" size="mini" icon="el-icon-edit" @click="editChannel(scope.$index, scope.row)">重置</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            
            <!-- 分页 -->
            <el-pagination class="pages" 
                :page-sizes="[25, 50, 75, 100]"
                @size-change="handleSizeChange" 
                @current-change="handleCurrentChange" 
                :page-size="pages.size" 
                :current-page="pages.page"
                background 
                layout="sizes,prev, pager, next" 
                :total="pages.count"> 
            </el-pagination>
            <!-- -->
        </div>
    </div>
</template>

<script>
import { evaluationList,cepingAll,resetEvaluation} from "@/api/reset";
export default {
    data() {
        return{
            list: [],
            pages: {},
            nickname:'',
            cid:null,
            obj:{},
            courseArr:[]
        }
    },
    methods:{
        // 修改状态
        editChannel(index,row){
            this.$confirm('是否清除当前测评状态?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$showLoading();
                resetEvaluation({
                    id:row.id
                }).then((data)=>{
                    this.$notify({
                        title: '成功',
                        message: '重置成功！',
                        type: 'success'
                    });
                    this.pullData();
                    this.$hideLoading();
                }).catch((err)=>{
                    this.$hideLoading();
                });
            });
        },
        
         // 调整每页显示条数
        handleSizeChange(val) {
            this.pages.size = val;
            this.pullData();
        },
        // 触发分页
        handleCurrentChange(val) {
            this.pages.page = val;
            this.pullData();
        },
        pullData(){
            this.$showLoading();
            this.obj = {
                page:Object.keys(this.pages).length>0?this.pages.page:1,  //页码，默认1
                size:Object.keys(this.pages).length>0?this.pages.size:25   //每页数量，默认25
            };
            // 判断如果有值为真的情况下传参,否则不传
            if(this.cid){
                this.obj['cid'] = this.cid;
            }
            if(this.nickname){
                this.obj['nickname'] = this.nickname;
            }
            evaluationList(this.obj).then((data)=>{
                this.list = data.list;
                this.pages = data.pager;
                
                this.$hideLoading();
            }).catch((err)=>{
                this.$hideLoading();
            });
            
        },
        // 获取全部测评
        getCeping(){
            // 获取全部测评
            cepingAll().then((data)=>{
                if(data.error>0){
                    this.$message(data.msg);
                    return
                }
                this.courseArr = data.list;
            });
        }
    },
    created(){
        this.getCeping();
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.main{
  position: relative;
}
.addBtn{
  position: absolute;
  left: 0;
  bottom: 0;
}
.pages{
  text-align: right;
  margin-top: 30px;
}
.pages-box{
    height: 32px;
    margin-top: 30px;
}
.preview{
    width: 300px;
    border-radius: 5px;
}
.box{
    margin-bottom: 20px;
}
.search{
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
}
.search.search-btn{
    flex: 1;
}
.search-gropu{
    flex: 1;
}
.search-gropu.on{
    flex: 1.5;
}
.search-child{
    margin-left: 20px;
    width: 200px;
}
.userinfo{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    img{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 15px;
    }
}
.el-input{
    width:200px;
}
</style>